import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { COMMON_API } from "../../commonAPI";

const TermsConditionList = () => {
  const [TermsConditions, setTermsConditions] = useState([]);
  const token = sessionStorage.getItem("authToken");
  const navigate = useNavigate();

  const fetchTermsConditions = async () => {
    try {
      const res = await axios.get(`${COMMON_API}/loan/getTermsCondition`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setTermsConditions(res.data.data || []);
    } catch (err) {
      console.error("Error fetching TermsConditions:", err);
    }
  };

  useEffect(() => {
    fetchTermsConditions();
  }, []);

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="bg-white shadow-lg rounded-2xl p-6 max-w-5xl mx-auto">
        <h2 className="text-2xl font-bold mb-4">TermsCondition List</h2>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300">
            <thead className="bg-gray-200">
              <tr>
                <th className="border px-4 py-2">ID</th>
                <th className="border px-4 py-2">Description</th>
                <th className="border px-4 py-2">Created At</th>
                <th className="border px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {TermsConditions.map((d) => (
                <tr key={d.id} className="hover:bg-gray-50">
                  <td className="border px-4 py-2">{d.id}</td>
                  <td className="border px-4 py-2 truncate max-w-md">{d.description}</td>
                  <td className="border px-4 py-2">
                    {new Date(d.createdAt).toLocaleString()}
                  </td>
                  <td className="border px-4 py-2">
                    <button
                      onClick={() => navigate(`/edit-terms-condition/${d.id}`)}
                      className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
              {TermsConditions.length === 0 && (
                <tr>
                  <td colSpan="4" className="text-center py-3 text-gray-500">
                    No Terms Conditions found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TermsConditionList;
